<div class="dialog-header">
  <h2 class="dialog-title">{{ title }}</h2>
  <button class="dialog-close" mat-dialog-close></button>
</div>
<div class="dialog-body">
  <ng-content select="dialog-body"></ng-content>
</div>
<div class="dialog-footer">
  <ng-content select="dialog-footer"></ng-content>
</div>
